import { useEffect, useState } from "react";
import { Check, Wand2 } from "lucide-react";
import { api, BACKEND_URL } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { UploadDrop } from "./UploadDrop";
import { CostTag } from "./CostTag";

const MODES = ["library", "prompt", "upload"];

export const BackgroundTab = ({ kind, onLaunch, disabled, costs = {} }) => {
  const { t, lang } = useLang();
  const [lib, setLib] = useState({ themes: [], items: [] });
  const [theme, setTheme] = useState("scifi");
  const [mode, setMode] = useState("library");
  const [picked, setPicked] = useState(null);
  const [own, setOwn] = useState(null);
  const [prompt, setPrompt] = useState("");

  useEffect(() => { api.library().then(setLib).catch(() => {}); }, []);
  const isVideo = kind === "video";

  const launch = () => {
    if (mode === "prompt") {
      onLaunch({ type: isVideo ? "video_bg_prompt" : "photo_bg_prompt", prompt, label: prompt.slice(0, 60) });
      return;
    }
    const bg = mode === "library" ? picked : own;
    const label = mode === "library" ? (lang === "fr" ? bg.name_fr : bg.name_en) : t("bg_upload");
    onLaunch({ type: isVideo ? "video_bg" : "photo_bg_image", background_file_id: bg.file_id || bg.id, label });
  };
  const ready = mode === "prompt" ? prompt.trim().length > 2 : mode === "library" ? !!picked : !!own;

  return (
    <div className="frz-tabpane" data-testid="tabpane-bg">
      <div className="frz-seg" role="tablist">
        {MODES.map((m) => (
          <button key={m} type="button" className={mode === m ? "on" : ""} onClick={() => setMode(m)} data-testid={`bg-mode-${m}`}>
            {t(`bg_${m}`)}
          </button>
        ))}
      </div>
      {mode === "library" && (
        <>
          <div className="frz-chips" data-testid="bg-themes">
            {lib.themes.map((th) => (
              <button key={th.id} type="button" className={`frz-chip ${theme === th.id ? "on" : ""}`} onClick={() => setTheme(th.id)} data-testid={`bg-theme-${th.id}`}>
                {th[lang]}
              </button>
            ))}
          </div>
          <div className="frz-lib-grid" data-testid="bg-library-grid">
            {lib.items.filter((i) => i.theme === theme).map((i) => (
              <button key={i.id} type="button" className={`frz-lib-item ${picked?.id === i.id ? "on" : ""}`} onClick={() => setPicked(i)} data-testid={`bg-item-${i.slug}`}>
                <img src={`${BACKEND_URL}${i.thumb_url}`} alt={lang === "fr" ? i.name_fr : i.name_en} loading="lazy" />
                <span>{lang === "fr" ? i.name_fr : i.name_en}</span>
                {picked?.id === i.id && <Check size={16} className="frz-lib-check" />}
              </button>
            ))}
          </div>
        </>
      )}
      {mode === "prompt" && (
        <textarea className="frz-textarea" rows={3} value={prompt} placeholder={t("bg_prompt_ph")} onChange={(e) => setPrompt(e.target.value)} data-testid="bg-prompt-input" />
      )}
      {mode === "upload" && (
        <div className="frz-own-bg">
          <UploadDrop compact imageOnly testId="bg-upload" title={own ? t("bg_change") : t("bg_upload_btn")} onFile={setOwn} />
          {own && <img src={`${BACKEND_URL}${own.url}`} alt="" className="frz-own-thumb" data-testid="bg-upload-preview" />}
        </div>
      )}
      <button type="button" className="frz-btn frz-btn-primary frz-btn-block" disabled={disabled || !ready} onClick={launch} data-testid="apply-bg-button">
        <Wand2 size={16} /> {ready ? t("apply_bg") : t("pick_bg_first")}
        <CostTag n={costs[isVideo ? (mode === "prompt" ? "video_bg_prompt" : "video_bg") : (mode === "prompt" ? "photo_bg_prompt" : "photo_bg_image")]} testId="bg-cost" />
      </button>
    </div>
  );
};
